import InputField from '@/components/common/Inputs/InputField';
import TextArea from '@/components/common/Inputs/TextArea';
import { Dialog, Transition } from '@headlessui/react';
import { MailIcon } from '@heroicons/react/outline';
import { Fragment, useRef, useState } from 'react';

export default function InputModal({
  setOpen,
  children,
  open,
  onClick,
  actionButton,
  subject,
  user,
}) {
  const cancelButtonRef = useRef(null);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  return (
    <>
      {/* FIXME button shifting layout */}
      <button
        type="button"
        className="hidden rounded-md bg-white font-medium text-rose-600 hover:text-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
        onClick={() => setOpen(true)}
      >
        {children}
      </button>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-20" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-20 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div>
                    <div className="flex flex-row">
                      <MailIcon className="mr-1 h-6 w-6 text-green-600" aria-hidden="true" />
                      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                        {user ? `Napisz do ${user.nickname}` : 'Napisz wiadomość'}
                      </Dialog.Title>
                    </div>
                    {subject && (
                      <div className="mt-3 text-left sm:mt-5">
                        <div className="mt-2">
                          <InputField
                            title="Tytuł"
                            value={title}
                            onChange={(title) => setTitle(title)}
                          ></InputField>
                        </div>
                      </div>
                    )}
                    <div className="mt-3 text-left sm:mt-5">
                      <div className="mt-2">
                        <TextArea
                          title="Treść wiadomości"
                          value={message}
                          onChange={(msg) => setMessage(msg)}
                          rows={3}
                        ></TextArea>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 flex flex-row-reverse justify-between gap-2 py-3">
                    <button
                      type="button"
                      className="inline-flex w-1/2 justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                      onClick={() => {
                        onClick(title, message);
                        setOpen(false);
                        setMessage('');
                      }}
                    >
                      {actionButton ? actionButton : 'Wyślij'}
                    </button>
                    <button
                      type="button"
                      className="inline-flex w-1/2 justify-center rounded-md border border-gray-300 bg-white px-10 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                      onClick={() => {
                        setOpen(false);
                        setMessage('');
                      }}
                      ref={cancelButtonRef}
                    >
                      Anuluj
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
